import { render } from "./MaterialIcons.vue?vue&type=template&id=b8cf1b8a&scoped=true&ts=true"
import script from "./MaterialIcons.vue?vue&type=script&lang=ts"
export * from "./MaterialIcons.vue?vue&type=script&lang=ts"

import "./MaterialIcons.vue?vue&type=style&index=0&id=b8cf1b8a&lang=scss&scoped=true"

import exportComponent from "/opt/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8cf1b8a"]])

export default __exports__